module.exports = __webpack_public_path__ + "img/placeholder.2fe09cae.jpg";